import {ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {AuthenticationApiService} from '../../../../projects/api/src/authentication/authentication-api.service';
import {loginPath} from '../../app-routing.constants';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
// import {MatSnackBar} from '@angular/material';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {BehaviorSubject} from 'rxjs/internal/BehaviorSubject';
import {Observable} from 'rxjs/internal/Observable';
import {HttpClient} from '@angular/common/http';
import {LoginInfo} from '../../../../projects/api/src/authentication/login-info.model';
import {environment} from '../../../environments/environment';
import {LogoAtommindComponent} from '../../shared/components/logo-atommind/logo-atommind.component';
import {LoginTextInputComponent} from '../../shared/forms/fields/login-text-input/login-text-input.component';
import {
  LoginPasswordInputComponent
} from '../../shared/forms/fields/login-password-input/login-password-input.component';
import {NgIf} from "@angular/common";

interface ResetPasswordFormModel {
  code: string;
  username: string;
  password: string;
}

@Component({
  selector: 'app-reset-password-form',
  templateUrl: './reset-password-form.component.html',
  styleUrls: ['./reset-password-form.component.scss'],
  standalone: true,
  imports: [
    LogoAtommindComponent,
    ReactiveFormsModule,
    TranslateModule,
    LoginTextInputComponent,
    LoginPasswordInputComponent,
    RouterLink,
    NgIf
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetPasswordFormComponent implements OnInit {

  readonly baseUrl = environment.backEndUrlPrefix + '/auth';
  public resetPasswordForm: FormGroup;
  errorMessage: BehaviorSubject<any> = new BehaviorSubject({});
  isErrorMessage = false;
  login;
  @HostListener('document:click', ['$event'])
  onMouseClick(e) {
    this.isErrorMessage = false;
  }
  constructor(private fb: FormBuilder,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private authenticationApiService: AuthenticationApiService,
              private translateService: TranslateService,
              //              private snackbar: MatSnackBar,
              private http: HttpClient,
              private ref: ChangeDetectorRef) {
    /*this.createForm();*/
  }

  ngOnInit() {
    this.activatedRoute.queryParams
      .subscribe(params => {
        this.login = params['login'] || '';
        this.createForm();
      });
  }

  onSubmit() {
    this.updatePassword(this.resetPasswordForm.value as ResetPasswordFormModel).subscribe(data => {
        this.isErrorMessage = false;
        //      this.snackbar.open(this.translateService.instant('Your password has been reset'), null, {duration: 2000});
        return this.router.navigateByUrl('/' + loginPath);
      }, error => {
        if (this.translateService.currentLang !== 'ru') {
          const translated = ListOfErrorMessages.filter((msg) => msg.cmp === error.error.Message);
          if (translated.length === 1) {
            this.errorMessage.next(translated[0].eng);
          } else if (error.error.Message) {
            this.errorMessage.next(error.error.Message);
          }
        } else {
          const translated = ListOfErrorMessages.filter((msg) => msg.cmp === error.error.Message);
          if (translated.length === 1) {
            this.errorMessage.next(translated[0].rus);
          } else if (error.error.Message) {
            this.errorMessage.next(error.error.Message);
          }
        }
        this.isErrorMessage = true;
        this.ref.detectChanges();
      }
    );
  }

  updatePassword(obj): Observable <any> {
    return this.http.post<LoginInfo>(this.baseUrl + '/reset_password', '', {params: obj});
  }

  createForm() {
    const form: ResetPasswordFormModel = {
      code: '',
      username: (this.login ? this.login : ''),
      password: ''
    };
    this.resetPasswordForm = this.fb.group(form as {[p: string]: any});
  }
}

export interface ErrorsLocale {
  cmp: string;
  rus: string;
  eng: string;
}
export const ListOfErrorMessages: ErrorsLocale[] = [
  // tslint:disable-next-line:max-line-length
  {cmp: 'Длина пароля не корректна. Пароль должен быть не менее 8 символов, должен содержать заглавные и строчные буквы, цифры и спецсимволы.', rus: 'Длина пароля не корректна. Пароль должен быть не менее 8 символов, должен содержать заглавные и строчные буквы, цифры и спецсимволы.',  eng: 'Password length is not correct. The password must be at least 8 characters, must contain upper and lower case letters, numbers and special characters.'},
  // tslint:disable-next-line:max-line-length
  {cmp: 'Пароль не содержит спецсимвол (@#$%^& и т.д.). Пароль должен быть не менее 8 символов, должен содержать заглавные и строчные буквы, цифры и спецсимволы.', rus: 'Пароль не содержит спецсимвол (@#$%^& и т.д.). Пароль должен быть не менее 8 символов, должен содержать заглавные и строчные буквы, цифры и спецсимволы.',  eng: 'The password does not contain a special character (@ # $% ^ & etc.). The password must be at least 8 characters, must contain upper and lower case letters, numbers and special characters.'},
  // tslint:disable-next-line:max-line-length
  {cmp: 'Пароль не содержит символов в верхнем регистре (ЗАГЛАВНЫХ БУКВ). Пароль должен быть не менее 8 символов, должен содержать заглавные и строчные буквы, цифры и спецсимволы.', rus: 'Пароль не содержит символов в верхнем регистре (ЗАГЛАВНЫХ БУКВ). Пароль должен быть не менее 8 символов, должен содержать заглавные и строчные буквы, цифры и спецсимволы.',  eng: 'The password does not contain uppercase characters (CAPITAL LETTERS). The password must be at least 8 characters, must contain upper and lower case letters, numbers and special characters.'},
  // tslint:disable-next-line:max-line-length
  {cmp: 'Пароль не содержит символов в нижнем регистре (строчных букв). Пароль должен быть не менее 8 символов, должен содержать заглавные и строчные буквы, цифры и спецсимволы.', rus: 'Пароль не содержит символов в нижнем регистре (строчных букв). Пароль должен быть не менее 8 символов, должен содержать заглавные и строчные буквы, цифры и спецсимволы.',  eng: 'The password does not contain lowercase characters (lower case letters). The password must be at least 8 characters, must contain upper and lower case letters, numbers and special characters.'},
  {cmp: 'Incorrect verification code.', rus: 'Неверный код верификации.',  eng: 'Incorrect verification code.'}
];
